<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="gridbom"
        title="감사팀 목록"
        tableId="gridbom"
        :columns="gridbom.columns"
        :data="gridbom.data"
        selection="multiple"
        rowKey="col1"
        :isFullScreen="false"
        :columnSetting="false"
        :filtering="false"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
              <c-btn v-if="editable" label="추가" icon="add" @btnClicked="addrow" />
              <c-btn v-if="editable" label="저장" icon="save" />
              <c-btn v-if="editable" label="삭제" icon="remove" @btnClicked="removerow" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hazop-plan-info',
  props: {
    param: {
      type: Object,
      default: () => ({
        disabled: false,
      }),
    },
  },
  data() {
    return {
      editable: true,
      gridbom: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '소속',
            align: 'center',
            type: 'text',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '직책',
            align: 'center',
            type: 'text',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '감사원명',
            align: 'center',
            sortable: false,
            type: 'text',
          },
          {
            name: 'col4',
            field: 'col4',
            label: '담당업무',
            align: 'center',
            type: 'text',
            sortable: false,
          },
          {
            name: 'col5',
            field: 'col5',
            label: '전공',
            align: 'center',
            type: 'text',
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.gridbom.data = [
        {
          col1: '공무팀',
          col2: '수석',
          col3: '홍길동',
          col4: '선임감사원',
          col5: '화학공학',
        },
        {
          col1: '생산1팀',
          col2: '책임',
          col3: '변사또',
          col4: '감사원',
          col5: '화학',
        },
      ]
    },
    addrow() {
      // 초기에는 userId에 tempId를 부여
      this.gridbom.data.splice(0, 0, {
        col0: '',
        col1: '',
        col2: '',
        col3: '',
        col4: '',
        col5: '',
      })
    },
    removerow() {
      let selectData = this.$refs['gridbom'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          this.gridbom.data = this.$_.reject(this.gridbom.data, { col2: item.col2 })
        })
      }
    },
  }
};
</script>
